export default __webpack_public_path__ + "static-front/media/SettingsIcon.eb671f3b.svg";